<template>
  <v-layout row wrap align-center >
    <v-flex xs12 class="text-xs-left pb-4">
      <p>Start the certificate program by confirming your identity. This is the KEY to workplace compliance.</p>
      <p>ID info is used for online proctoring and issuing the eBadge and certificate.</p>
      <v-layout>
        <v-flex>
          <ul>
            <li>Email address</li>
            <li>Mobile number</li>
          </ul>
        </v-flex>
        <v-flex>
          <ul>
            <li>Name</li>
            <li>Street address</li>
          </ul>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12 >
      <v-text-field
        @keyup="changedEmail=true"
        @keyup.enter="confirmMyEmail"
        v-validate="'required|email'"
        autocomplete="new-password"
        :autofocus=true
        type="email"
        :error-messages="errors.collect('slot1.email')"
        data-vv-name="slot1.email"
        data-vv-scope="slot1"
        v-model="email"
        data-vv-validate-on="blur"
        label="E-mail address"
      ></v-text-field>
    </v-flex>

    <v-flex xs12 class="text-lg-left" v-if="!emailVerified">
      <v-btn
        block
        @click="confirmMyEmail"
        :disabled="!changedEmail || !email"
        :loading="loading" class="mr-0 ml-0"
        color="success">Get Started</v-btn>

      <v-btn
        v-if="otpGenerated"
        block
        @click="goToSignupStep(page, 'code-verification')"
        color="primary">Next &#8594;</v-btn>

    </v-flex>

    <v-flex xs12 class="text-lg-left" v-if="emailVerified">
      <v-btn
        block
        @click="confirmMyEmail"
        :disabled="!changedEmail"
        :loading="loading"
        class="mr-0 ml-0"
        color="success">Update</v-btn>
      <v-btn
        block
        @click="goToSignupStep(page, 'confirm-my-phone')"
        color="primary">Next &#8594;</v-btn>

    </v-flex>

    <v-flex align-center class="mt-5 grey--text">
      <p>
        Your personal data is kept secure, private and only used to operate your certificate program.
      </p>
      <p>
        We do not sell, give or show personal info to anyone else without your permission.
      </p>
    </v-flex>

    <v-dialog v-model="accountExistsDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline" v-text="'Account Exists'"/>
        <v-card-text>
          <p>Hello {{fName}},</p>
          <p>Your email id <span class="font-weight-bold" v-text="email"/> is already registered.</p>
          <p>To complete the registration process of <span class="font-weight-bold">{{appName}}</span>,
            please SIGN IN with the same email id and update your profile.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat to="/">Sign IN</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import crypto from '@/mixins/crypto'
import common from '@/mixins/common'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ConfirmMyEmail',
  data () {
    return {
      loading: false,
      changedEmail: false,
      accountExistsDialog: false,
      apiUrl: process.env.API_URL,
      appName: process.env.APP_NAME,
      fName: '',
      lName: '',
      email: '',
      errorMsg: '',
      isLoader: false,
      dictionary: {
        custom: {
          'slot1.email': {
            required: () => 'Email is required',
            email: 'Please enter valid email id'
          }
        }
      }
    }
  },
  props: {
    page: {
      default: 'SignUp',
      type: String
    }
  },
  computed: {
    inputClassEmail () {
      return this.errorMsg !== '' ? 'validate invalid' : this.email !== '' ? 'validate valid' : ''
    },
    ...mapGetters('registration', ['getUserDetails']),

    emailVerified () {
      return this.getUserDetails.email_verified
    },
    otpGenerated () {
      return this.getUserDetails.email_otp_generated
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
    this.email = this.decryptData(this.getUserDetails.email)
  },
  methods: {
    ...mapMutations('registration', [
      'setUser'
    ]),
    confirmMyEmail () {
      this.loading = true
      this.errors.clear('slot1')
      this.$store.dispatch('registration/sendOtp', this.email)
        .then((res) => {
          // console.log(res)
          if (res.userState && res.userState === 2) {
            this.accountExistsDialog = true
            this.fName = res.firstName
            this.lName = res.lastName
          } else {
            console.log('Response:', res)
            this.setUser({
              ...this.getUserDetails,
              email: this.encryptData(this.email),
              email_otp_generated: true,
              email_otp_id: res.data.otpId})

            this.$router.push({name: 'SignUp',
              params: {step: 'code-verification', otp_id: res.data.otpId}})
          }
          this.loading = false
        }, (err) => {
          this.loading = false
          this.errorMsg = 'Invalid email address.'
          this.errors.add({
            scope: 'slot1',
            field: 'email',
            msg: 'Invalid email address'
          })
          console.log('error found', err)
        }).catch((e) => {
          this.loading = false
          console.log('Caught', e)
        })
    }
  },
  mixins: [crypto, common]
}
</script>



// WEBPACK FOOTER //
// src/components/views/sign-up/ConfirmMyEmail.vue